"use client";

import { c as _c } from "react/compiler-runtime";
import { useForm } from "react-hook-form";
import { Button } from "@/shared/components/ui/button";
import FormInput from "@/shared/components/ui/form-input";
import { Dumbbell, User, Mail, PhoneCall, Lock, ArrowRight } from "lucide-react";
import Link from "next/link";
import { zodResolver } from "@hookform/resolvers/zod";
import { registerSchema } from "../validations/client-validation";
import { useActionHandler } from "@/shared/hooks/use-action-handler";
import { registerAction } from "../auth-actions";
import { Spinner } from "@/shared/components/ui/spinner";
const RegisterForm = () => {
  const $ = _c(49);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = zodResolver(registerSchema);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: t0,
      mode: "onSubmit",
      defaultValues: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        phone: ""
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    control,
    reset,
    handleSubmit
  } = useForm(t1);
  const {
    handleAction,
    loading
  } = useActionHandler();
  let t2;
  if ($[2] !== handleAction || $[3] !== reset) {
    t2 = async data => {
      await handleAction(registerAction, data, {
        onSuccess: () => {
          reset();
        }
      });
    };
    $[2] = handleAction;
    $[3] = reset;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleSubmit || $[6] !== t2) {
    t3 = handleSubmit(t2);
    $[5] = handleSubmit;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const onSubmit = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-center mb-3"><Link href="/" className="inline-flex items-center justify-center w-20 h-20 bg-brand-primary/10  bg-primary rounded-full"><Dumbbell className="w-10 h-10 text-brand-primary -rotate-45 hover:rotate-180 transition-transform duration-500 text-accent" /></Link><h2 className="text-3xl  tracking-tight mb-1">Create Account</h2><p className="text-muted-foreground text-sm ">Enter your details to register your gym.</p></div>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <User size={18} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== control || $[11] !== loading) {
    t6 = <FormInput label="First Name" name="firstName" type="text" placeholder="John" icon={t5} control={control} disabled={loading} />;
    $[10] = control;
    $[11] = loading;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <User size={18} />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== control || $[15] !== loading) {
    t8 = <FormInput control={control} label="Last Name" name="lastName" type="text" placeholder="Doe" icon={t7} disabled={loading} />;
    $[14] = control;
    $[15] = loading;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Mail size={18} />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== control || $[22] !== loading) {
    t11 = <FormInput label="Email" name="email" type="text" placeholder="owner@gymmart.com" icon={t10} control={control} disabled={loading} />;
    $[21] = control;
    $[22] = loading;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <PhoneCall size={18} />;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== control || $[26] !== loading) {
    t13 = <FormInput label="Phone Number" name="phone" type="tel" placeholder="+91" icon={t12} control={control} disabled={loading} />;
    $[25] = control;
    $[26] = loading;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Lock size={18} />;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== control || $[30] !== loading) {
    t15 = <FormInput disabled={loading} type="password" placeholder="*********" icon={t14} control={control} label="Password" name="password" />;
    $[29] = control;
    $[30] = loading;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span className="text-accent">Create Account</span>;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== loading) {
    t17 = loading ? <Spinner className="text-accent" /> : <ArrowRight size={20} className="group-hover:translate-x-2 transition-transform  text-accent" />;
    $[33] = loading;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== loading || $[36] !== t17) {
    t18 = <Button type="submit" className="group text-accent-foreground w-full flex items-center justify-center gap-2 py-4 px-6     transition-all duration-200 transform active:scale-[0.98]  shadow-brand-primary/20" disabled={loading}>{t16}{t17}</Button>;
    $[35] = loading;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== loading || $[39] !== onSubmit || $[40] !== t11 || $[41] !== t13 || $[42] !== t15 || $[43] !== t18 || $[44] !== t9) {
    t19 = <form onSubmit={onSubmit} className="space-y-4" aria-busy={loading}>{t9}{t11}{t13}{t15}{t18}</form>;
    $[38] = loading;
    $[39] = onSubmit;
    $[40] = t11;
    $[41] = t13;
    $[42] = t15;
    $[43] = t18;
    $[44] = t9;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="text-center space-y-6"><p className="text-sm  text-muted-foreground">Already have an account?{" "}<Link href="/login" className="  hover:text-brand-primary transition-colors hover:underline font-semibold text-primary">Log In</Link></p></div>;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t19) {
    t21 = <div className="w-full max-w-110 flex flex-col   space-y-2 px-2 md:px-0">{t4}{t19}{t20}</div>;
    $[47] = t19;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  return t21;
};
export default RegisterForm;